import React from "react";
import { GlobalStyles } from "@mui/material";

import GTUltraStandardLloydsLight from "../../assets/fonts/GT-Ultra-Standard-Lloyds-Light.ttf";
import GTUltraStandardLloydsRegular from "../../assets/fonts/GT-Ultra-Standard-Lloyds-Regular.ttf";
import GTUltraStandardLloydsBold from "../../assets/fonts/GT-Ultra-Standard-Lloyds-Bold.ttf";
import GTUltraMedianLloydsRegular from "../../assets/fonts/GT-Ultra-Median-Lloyds-Regular.ttf";
import GTUltraMedianLloydsBold from "../../assets/fonts/GT-Ultra-Median-Lloyds-Bold.ttf";

const lloydsFontStyles = `
  @font-face {
    font-family: 'GT Ultra';
    src: url('${GTUltraStandardLloydsLight}') format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'GT Ultra';
    src: url('${GTUltraStandardLloydsRegular}') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'GT Ultra';
    src: url('${GTUltraStandardLloydsBold}') format('truetype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'GT Ultra Lloyds';
    src: url('${GTUltraMedianLloydsRegular}') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'GT Ultra Lloyds';
    src: url('${GTUltraMedianLloydsBold}') format('truetype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
`;

export const LloydsFontLoader: React.FC = () => <GlobalStyles styles={lloydsFontStyles} />;
